var map = {
	"./house1.png": 1015,
	"./house10.png": 1016,
	"./house11.png": 1017,
	"./house12.png": 1018,
	"./house13.png": 1019,
	"./house2.png": 1020,
	"./house3.png": 1021,
	"./house4.png": 1022,
	"./house5.png": 1023,
	"./house6.png": 1024,
	"./house7.png": 1025,
	"./house8.png": 1026,
	"./house9.png": 1027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;